export default __webpack_public_path__ + "static/media/ConNovedad.20ab62a8.svg";